import { z } from 'zod';
import { apiUrl } from '../config/api';
import type { Project } from '../data/databaseSchema';
import { apiClient } from '../lib/apiClient';
import { apiResponseSchema, projectSchema } from '../lib/schemas';

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

// Project administration moved to another application; only reads remain.
export const projectService = {
  async getProjects(): Promise<Project[]> {
    const result = await apiClient.get(apiUrl.projects(), {
      validate: apiResponseSchema(z.array(projectSchema)),
      deduplicate: true,
      context: 'getProjects',
    });
    return result.data;
  },

  async getProjectsByRole(): Promise<Project[]> {
    const result = await apiClient.get(apiUrl.projectsByRole(), {
      validate: apiResponseSchema(z.array(projectSchema)),
      deduplicate: true,
      context: 'getProjectsByRole',
    });
    return result.data;
  },
};
